var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var models;
    (function (models) {
        var ObjectQueryPredicateStateChange;
        (function (ObjectQueryPredicateStateChange) {
            ObjectQueryPredicateStateChange[ObjectQueryPredicateStateChange["LeftPredicate"] = 0] = "LeftPredicate";
            ObjectQueryPredicateStateChange[ObjectQueryPredicateStateChange["Operator"] = 1] = "Operator";
            ObjectQueryPredicateStateChange[ObjectQueryPredicateStateChange["RightRistrictionType"] = 2] = "RightRistrictionType";
        })(ObjectQueryPredicateStateChange = models.ObjectQueryPredicateStateChange || (models.ObjectQueryPredicateStateChange = {}));
        var ExtendedQueryColumnDataType;
        (function (ExtendedQueryColumnDataType) {
            ExtendedQueryColumnDataType[ExtendedQueryColumnDataType["String"] = 0] = "String";
            ExtendedQueryColumnDataType[ExtendedQueryColumnDataType["Date"] = 1] = "Date";
            ExtendedQueryColumnDataType[ExtendedQueryColumnDataType["Number"] = 2] = "Number";
            ExtendedQueryColumnDataType[ExtendedQueryColumnDataType["Boolean"] = 3] = "Boolean";
            ExtendedQueryColumnDataType[ExtendedQueryColumnDataType["ReviewType"] = 4] = "ReviewType";
            ExtendedQueryColumnDataType[ExtendedQueryColumnDataType["State"] = 5] = "State";
            ExtendedQueryColumnDataType[ExtendedQueryColumnDataType["Status"] = 6] = "Status";
            ExtendedQueryColumnDataType[ExtendedQueryColumnDataType["User"] = 7] = "User";
            ExtendedQueryColumnDataType[ExtendedQueryColumnDataType["Claim"] = 8] = "Claim";
            ExtendedQueryColumnDataType[ExtendedQueryColumnDataType["ReviewConfiguration"] = 9] = "ReviewConfiguration";
            ExtendedQueryColumnDataType[ExtendedQueryColumnDataType["UserEmail"] = 10] = "UserEmail";
        })(ExtendedQueryColumnDataType = models.ExtendedQueryColumnDataType || (models.ExtendedQueryColumnDataType = {}));
        var ExtendedQueryColumn = /** @class */ (function () {
            function ExtendedQueryColumn(column, systemColumn, dataType, displayName, aliasName) {
                this.column = column;
                this.systemColumn = systemColumn;
                this.dataType = dataType;
                this.displayName = displayName;
                this.aliasName = aliasName;
            }
            return ExtendedQueryColumn;
        }());
        models.ExtendedQueryColumn = ExtendedQueryColumn;
        var CommentInformationQueryMap = /** @class */ (function () {
            function CommentInformationQueryMap() {
                this.listName = "_CommentInfos";
                this.columns = [
                    new ExtendedQueryColumn("ReviewConfigurationUniqueId", "SystemReviewGroupId", ExtendedQueryColumnDataType.ReviewConfiguration, "Review Configuration", "_ReviewConfiguration"),
                    new ExtendedQueryColumn("CommentType", "CommentType", ExtendedQueryColumnDataType.String, "Comment Type", "_CommentType"),
                    new ExtendedQueryColumn("CommentStatus", "CommentStatus", ExtendedQueryColumnDataType.String, "Comment Status", "_CommentStatus"),
                    new ExtendedQueryColumn("CommentingUserId", "CommentingUserId", ExtendedQueryColumnDataType.User, "Commenting User", "_CommentingUser"),
                    new ExtendedQueryColumn("Comment", "Comment", ExtendedQueryColumnDataType.String, "Comment", "_Comment"),
                    new ExtendedQueryColumn("CommentDateTime", "CommentDateTime", ExtendedQueryColumnDataType.Date, "Comment Date-Time", "_CommentDateTime")
                ];
            }
            return CommentInformationQueryMap;
        }());
        models.CommentInformationQueryMap = CommentInformationQueryMap;
        var StatusHistoryQueryMap = /** @class */ (function () {
            function StatusHistoryQueryMap() {
                this.listName = "_StatusHistories";
                this.columns = [
                    new ExtendedQueryColumn("ProcessLevelStatusUniqueIdentifier", "SystemLevelStatusUniqueIdentifier", ExtendedQueryColumnDataType.Status, "Status", "_Status"),
                    new ExtendedQueryColumn("StatusEffectiveDate", "StatusEffectiveDate", ExtendedQueryColumnDataType.Date, "Status Effective Date", "_StatusEffectiveDate"),
                    new ExtendedQueryColumn("ProcessLevelStateUniqueIdentifier", "SystemLevelStateUniqueIdentifier", ExtendedQueryColumnDataType.State, "State", "_State"),
                    new ExtendedQueryColumn("StateEffectiveDate", "StateEffectiveDate", ExtendedQueryColumnDataType.Date, "State Effective Date", "_StateEffectiveDate"),
                    new ExtendedQueryColumn("OccurrenceIndex", "OccurrenceIndex", ExtendedQueryColumnDataType.Number, "Order", "_Order")
                ];
            }
            return StatusHistoryQueryMap;
        }());
        models.StatusHistoryQueryMap = StatusHistoryQueryMap;
        var AssignmentQueryMap = /** @class */ (function () {
            function AssignmentQueryMap() {
                this.listName = "_AssignmentInfos";
                this.columns = [
                    new ExtendedQueryColumn("ClaimDefinitionUniqueIdentifier", "SystemClaimGroupId", ExtendedQueryColumnDataType.Claim, "Claim", "_Claim"),
                    new ExtendedQueryColumn("AssignedUserId", "AssignedUserId", ExtendedQueryColumnDataType.User, "Assigned To User", "_AssignedToUser"),
                    new ExtendedQueryColumn("AssignorUserId", "AssignorUserId", ExtendedQueryColumnDataType.User, "Assigned By User", "_AssignedByUser"),
                    new ExtendedQueryColumn("AssignedUserId_EMAIL", "AssignedUserId_EMAIL", ExtendedQueryColumnDataType.UserEmail, "Assigned To User Email", "_AssignedToUserEmail"),
                    new ExtendedQueryColumn("AssignorUserId_EMAIL", "AssignorUserId_EMAIL", ExtendedQueryColumnDataType.UserEmail, "Assigned By User Email", "_AssignedByUserEmail")
                ];
            }
            return AssignmentQueryMap;
        }());
        models.AssignmentQueryMap = AssignmentQueryMap;
        var ReviewInformationQueryMap = /** @class */ (function () {
            function ReviewInformationQueryMap() {
                this.listName = "_ReviewInfos";
                this.columns = [
                    new ExtendedQueryColumn("ReviewConfigurationUniqueId", "SystemReviewGroupId", ExtendedQueryColumnDataType.ReviewConfiguration, "Review Configuration", "_ReviewConfiguration"),
                    new ExtendedQueryColumn("ReviewTypeSystemCodeUniqueId", "ReviewTypeSystemCodeUniqueId", ExtendedQueryColumnDataType.ReviewType, "Review Type", "_ReviewType"),
                    new ExtendedQueryColumn("AssignedDate", "AssignedDate", ExtendedQueryColumnDataType.Date, "Assigned Date", "_AssignedDate"),
                    new ExtendedQueryColumn("DueDate", "DueDate", ExtendedQueryColumnDataType.Date, "Due Date", "_DueDate"),
                    new ExtendedQueryColumn("ClosedDate", "ClosedDate", ExtendedQueryColumnDataType.Date, "Closed Date", "_ClosedDate"),
                    new ExtendedQueryColumn("IsComplete", "IsComplete", ExtendedQueryColumnDataType.Boolean, "Review Complete", "_ReviewComplete"),
                    new ExtendedQueryColumn("IsReviewSetComplete", "IsReviewSetComplete", ExtendedQueryColumnDataType.Boolean, "Review Set Complete", "_ReviewSetComplete"),
                    new ExtendedQueryColumn("AssignedUserId", "AssignedUserId", ExtendedQueryColumnDataType.User, "Assigned To User", "_AssignedToUser"),
                    new ExtendedQueryColumn("AssignorUserId", "AssignorUserId", ExtendedQueryColumnDataType.User, "Assigned By User", "_AssignedByUser"),
                    new ExtendedQueryColumn("AssignedUserId_EMAIL", "AssignedUserId_EMAIL", ExtendedQueryColumnDataType.UserEmail, "Assigned To User Email", "_AssignedToUserEmail"),
                    new ExtendedQueryColumn("AssignorUserId_EMAIL", "AssignorUserId_EMAIL", ExtendedQueryColumnDataType.UserEmail, "Assigned By User Email", "_AssignedByUserEmail"),
                    new ExtendedQueryColumn("Comment", "Comment", ExtendedQueryColumnDataType.String, "Comment", "_Comment")
                ];
            }
            return ReviewInformationQueryMap;
        }());
        models.ReviewInformationQueryMap = ReviewInformationQueryMap;
        var ObjectQueryPredicate = /** @class */ (function (_super) {
            __extends(ObjectQueryPredicate, _super);
            function ObjectQueryPredicate() {
                var _this = _super.call(this) || this;
                _this.showValueTarget = false;
                _this.showParameterName = false;
                _this.showParameterTarget = false;
                _this.statusHistoryQueryMap = new StatusHistoryQueryMap();
                _this.assignmentQueryMap = new AssignmentQueryMap();
                _this.reviewInformationQueryMap = new ReviewInformationQueryMap();
                _this.commentInformationQueryMap = new CommentInformationQueryMap();
                _this.propertyTypeContext = new models.EnumDropDownContext();
                _this.operatorTypeContext = new models.EnumDropDownContext();
                _this.rightRestrictionTypeContext = new models.EnumDropDownContext();
                _this.stateChange = ObjectQueryPredicateStateChange.LeftPredicate;
                return _this;
            }
            ObjectQueryPredicate.prototype.getExtendedQueryColumn = function () {
                var self = this;
                if (self.propertyType === 8 /* Assignment */) {
                    return Enumerable.from(self.assignmentQueryMap.columns)
                        .where(function (i) { return i.column === self.reportDataSubTableColumnName; })
                        .singleOrDefault();
                }
                if (self.propertyType === 9 /* ReviewInformation */) {
                    return Enumerable.from(self.reviewInformationQueryMap.columns)
                        .where(function (i) { return i.column === self.reportDataSubTableColumnName; })
                        .singleOrDefault();
                }
                if (self.propertyType === 6 /* StatusHistory */) {
                    return Enumerable.from(self.statusHistoryQueryMap.columns)
                        .where(function (i) { return i.column === self.reportDataSubTableColumnName; })
                        .singleOrDefault();
                }
                if (self.propertyType === 12 /* CommentInformation */) {
                    return Enumerable.from(self.commentInformationQueryMap.columns)
                        .where(function (i) { return i.column === self.reportDataSubTableColumnName; })
                        .singleOrDefault();
                }
                return null;
            };
            ObjectQueryPredicate.prototype.setValidValues = function (isProcessLevel) {
                var self = this;
                self.operatorTypeContext.removeSpecifiedOptions = [];
                self.rightRestrictionTypeContext.removeSpecifiedOptions = [];
                self.propertyTypeContext.removeSpecifiedOptions = [];
                //self.propertyTypeContext.removeSpecifiedOptions.push(Wars.Domain.Model.Codes.Enums.ObjectQueryPropertyType.ProcessId);
                if (isProcessLevel || self.processTypes.length === 0) {
                    self.propertyTypeContext.removeSpecifiedOptions.push(4 /* ProcessType */);
                }
                if (self.states == null || self.states.length === 0) {
                    self.propertyTypeContext.removeSpecifiedOptions.push(1 /* State */);
                }
                if (self.statuses == null || self.statuses.length === 0) {
                    self.propertyTypeContext.removeSpecifiedOptions.push(2 /* Status */);
                    self.propertyTypeContext.removeSpecifiedOptions.push(6 /* StatusHistory */);
                }
                if (self.reviewConfigurations == null || self.reviewConfigurations.length === 0) {
                    self.propertyTypeContext.removeSpecifiedOptions.push(9 /* ReviewInformation */);
                }
                if (self.assignmentClaims == null || self.assignmentClaims.length === 0) {
                    self.propertyTypeContext.removeSpecifiedOptions.push(8 /* Assignment */);
                }
                //row id
                if (self.propertyType === 3 /* RowId */
                    || self.propertyType === 10 /* ProcessId */
                    || (self.propertyType === 0 /* Property */
                        && self.leftReportDataTreeItem != null
                        && self.leftReportDataTreeItem.variableType === 31 /* ProcessId */)) {
                    self.removeAllRightRestrictionsExcept([
                        7 /* SubQuery */,
                        1 /* InputParameterValue */
                    ]);
                    self.removeAllOperatorsExcept([
                        11 /* In */,
                        12 /* NotIn */,
                        0 /* Equals */
                    ]);
                }
                if (self.propertyType === 5 /* ProcessInitiator */) {
                    self.removeAllRightRestrictionsExcept([
                        6 /* Value */,
                        1 /* InputParameterValue */
                    ]);
                    self.removeAllOperatorsExcept([0 /* Equals */]);
                }
                if (self.rightRestrictionType === 9 /* Claim */) {
                    self.removeAllOperatorsExcept([
                        11 /* In */,
                        12 /* NotIn */
                    ]);
                }
                //state, status, or process type
                if (self.propertyType !== 18 /* StateLastUpdatedDate */ &&
                    self.propertyType !== 16 /* StatusLastUpdatedDate */) {
                    if (self.propertyType === 1 /* State */
                        || self.propertyType === 2 /* Status */
                        || self.propertyType === 17 /* StateLastUpdatedBy */
                        || self.propertyType === 15 /* StatusLastUpdatedBy */
                        || self.propertyType === 4 /* ProcessType */
                        || self.propertyType === 11 /* ProcessSubType */) {
                        if (self.operatorType === 0 /* Equals */
                            || self.operatorType === 1 /* NotEqual */) {
                            self.removeAllOperatorsExcept([
                                0 /* Equals */,
                                1 /* NotEqual */
                            ]);
                        }
                        else {
                            self.removeAllOperatorsExcept([
                                11 /* In */,
                                12 /* NotIn */
                            ]);
                        }
                        if (self.propertyType === 17 /* StateLastUpdatedBy */ ||
                            self.propertyType === 15 /* StatusLastUpdatedBy */) {
                            self.removeAllRightRestrictionsExcept([
                                1 /* InputParameterValue */,
                                5 /* PlaceHolder */,
                                2 /* InputParameterList */
                            ]);
                        }
                        else {
                            self.removeAllRightRestrictionsExcept([
                                1 /* InputParameterValue */,
                                6 /* Value */,
                                2 /* InputParameterList */
                            ]);
                        }
                    }
                }
                //extended predicates
                var column;
                if (self.propertyType === 8 /* Assignment */
                    || self.propertyType === 9 /* ReviewInformation */
                    || self.propertyType === 6 /* StatusHistory */
                    || self.propertyType === 12 /* CommentInformation */) {
                    column = self.getExtendedQueryColumn();
                    if (column.dataType === ExtendedQueryColumnDataType.Claim ||
                        column.dataType === ExtendedQueryColumnDataType.ReviewType ||
                        column.dataType === ExtendedQueryColumnDataType.ReviewConfiguration ||
                        column.dataType === ExtendedQueryColumnDataType.State ||
                        column.dataType === ExtendedQueryColumnDataType.Status) {
                        if (self.operatorType === 0 /* Equals */
                            || self.operatorType === 1 /* NotEqual */
                            || self.operatorType === 9 /* IsNull */
                            || self.operatorType === 10 /* IsNotNull */) {
                            self.removeAllOperatorsExcept([
                                0 /* Equals */,
                                1 /* NotEqual */,
                                9 /* IsNull */,
                                10 /* IsNotNull */
                            ]);
                        }
                        else {
                            self.removeAllOperatorsExcept([
                                11 /* In */,
                                12 /* NotIn */
                            ]);
                        }
                        self.removeAllRightRestrictionsExcept([
                            1 /* InputParameterValue */,
                            6 /* Value */,
                            2 /* InputParameterList */
                        ]);
                    }
                }
                else if (self.leftReportDataTreeItem == null) {
                    self.booleanValue = null;
                    self.transientBooleanValue = "";
                    return;
                }
                //boolean value
                if ((column != null && column.dataType === ExtendedQueryColumnDataType.Boolean)
                    || self.leftReportDataTreeItem != null && self.leftReportDataTreeItem.variableType === 6 /* Boolean */) {
                    if (self.booleanValue === null || self.booleanValue === false) {
                        self.transientBooleanValue = "";
                    }
                    else {
                        self.transientBooleanValue = "1";
                    }
                }
                else {
                    self.transientBooleanValue = "";
                    self.booleanValue = null;
                }
                //operator is = null
                if (self.operatorType === 9 /* IsNull */
                    || self.operatorType === 10 /* IsNotNull */) {
                    self.removeAllRightRestrictionsExcept([0 /* None */]);
                }
                else {
                    self.rightRestrictionTypeContext.removeSpecifiedOptions.push(0 /* None */);
                }
                //a list type predicate
                if (self.rightRestrictionType === 2 /* InputParameterList */
                    || self.rightRestrictionType === 7 /* SubQuery */) {
                    self.removeAllOperatorsExcept([
                        11 /* In */,
                        12 /* NotIn */,
                        9 /* IsNull */,
                        10 /* IsNotNull */
                    ]);
                }
                else {
                    if (self.rightRestrictionType !== 9 /* Claim */) {
                        self.operatorTypeContext.removeSpecifiedOptions.push(11 /* In */);
                        self.operatorTypeContext.removeSpecifiedOptions.push(12 /* NotIn */);
                    }
                }
                //left predicate is not a code
                if ((column != null && column.dataType !== ExtendedQueryColumnDataType.State
                    && column.dataType !== ExtendedQueryColumnDataType.Status
                    && column.dataType !== ExtendedQueryColumnDataType.ReviewConfiguration
                    && column.dataType !== ExtendedQueryColumnDataType.ReviewType
                    && column.dataType !== ExtendedQueryColumnDataType.Claim
                    && column.dataType !== ExtendedQueryColumnDataType.Boolean)
                    || (self.leftReportDataTreeItem != null && self.leftReportDataTreeItem.schemaProperty.codeGroup_id === null && self.leftReportDataTreeItem.variableType !== 6 /* Boolean */)) {
                    self.rightRestrictionTypeContext.removeSpecifiedOptions.push(6 /* Value */);
                }
                //not a string type predicate
                if ((column != null && column.dataType !== ExtendedQueryColumnDataType.String)
                    || (self.leftReportDataTreeItem != null && self.leftReportDataTreeItem.variableType !== 0 /* String */)) {
                    self.operatorTypeContext.removeSpecifiedOptions.push(8 /* LikeAnywhere */);
                    self.operatorTypeContext.removeSpecifiedOptions.push(7 /* LikeEnd */);
                    self.operatorTypeContext.removeSpecifiedOptions.push(6 /* LikeStart */);
                }
            };
            ObjectQueryPredicate.prototype.onLeftPredicateChange = function (isProcessLevel) {
                var self = this;
                self.stateChange = ObjectQueryPredicateStateChange.LeftPredicate;
                if (self.operatorType !== 0 /* Equals */) {
                    self.operatorType = 0 /* Equals */;
                    if (self.stateChange < ObjectQueryPredicateStateChange.RightRistrictionType) {
                        self.stateChange = ObjectQueryPredicateStateChange.Operator;
                    }
                }
                if (self.rightRestrictionType !== 1 /* InputParameterValue */) {
                    self.rightRestrictionType = 1 /* InputParameterValue */;
                    self.stateChange = ObjectQueryPredicateStateChange.RightRistrictionType;
                }
                self.setValidValues(isProcessLevel);
            };
            ObjectQueryPredicate.prototype.onOperatorChange = function (isProcessLevel) {
                var self = this;
                if (self.stateChange < ObjectQueryPredicateStateChange.RightRistrictionType) {
                    self.stateChange = ObjectQueryPredicateStateChange.Operator;
                }
                //operator is = null, so set right restriction to none and remove other options
                if (self.operatorType === 9 /* IsNull */
                    || self.operatorType === 10 /* IsNotNull */) {
                    self.rightRestrictionType = 0 /* None */;
                    self.stateChange = ObjectQueryPredicateStateChange.RightRistrictionType;
                }
                else if (self.rightRestrictionType === 0 /* None */) {
                    //changed from a null predicate, so set restriction type to input parameter
                    self.rightRestrictionType = 1 /* InputParameterValue */;
                    self.stateChange = ObjectQueryPredicateStateChange.RightRistrictionType;
                }
                self.setValidValues(isProcessLevel);
            };
            ObjectQueryPredicate.prototype.onRightRestrictionTypeChange = function (isProcessLevel) {
                var self = this;
                var column;
                if (self.propertyType === 8 /* Assignment */ ||
                    self.propertyType === 9 /* ReviewInformation */ ||
                    self.propertyType === 6 /* StatusHistory */ ||
                    self.propertyType === 12 /* CommentInformation */) {
                    column = self.getExtendedQueryColumn();
                }
                //non-field or row ID property type 
                if (self.propertyType !== 0 /* Property */
                    && self.propertyType !== 3 /* RowId */
                    && (column == null || (column != null && (column.dataType === ExtendedQueryColumnDataType.State || column.dataType === ExtendedQueryColumnDataType.Status)))) {
                    if (self.rightRestrictionType === 1 /* InputParameterValue */
                        || self.rightRestrictionType === 6 /* Value */) {
                        self.operatorTypeContext.removeSpecifiedOptions = [];
                        if (self.propertyType !== 18 /* StateLastUpdatedDate */
                            && self.propertyType !== 16 /* StatusLastUpdatedDate */) {
                            self.removeAllOperatorsExcept([
                                0 /* Equals */,
                                1 /* NotEqual */
                            ]);
                            if (self.operatorType !== 0 /* Equals */
                                && self.operatorType !== 1 /* NotEqual */) {
                                self.operatorType = 0 /* Equals */;
                            }
                        }
                    }
                    if (self.rightRestrictionType === 2 /* InputParameterList */
                        || self.rightRestrictionType === 7 /* SubQuery */) {
                        self.operatorTypeContext.removeSpecifiedOptions = [];
                        self.removeAllOperatorsExcept([
                            11 /* In */,
                            12 /* NotIn */
                        ]);
                        if (self.operatorType !== 11 /* In */
                            && self.operatorType !== 12 /* NotIn */) {
                            self.operatorType = 11 /* In */;
                        }
                    }
                    if (self.propertyType === 4 /* ProcessType */) {
                        self.stateUniqueIdentifier = null;
                        self.statusUniqueIdentifier = null;
                        self.assignmentClaimIdentifier = null;
                        self.reviewConfigurationIdentifier = null;
                        self.reviewTypeIdentifier = null;
                        self.processSubType_id = null;
                    }
                    if (self.propertyType === 11 /* ProcessSubType */) {
                        self.stateUniqueIdentifier = null;
                        self.statusUniqueIdentifier = null;
                        self.assignmentClaimIdentifier = null;
                        self.reviewConfigurationIdentifier = null;
                        self.reviewTypeIdentifier = null;
                        self.processType = null;
                        self.processType_id = null;
                    }
                    if (self.propertyType === 1 /* State */
                        || (column != null && column.dataType === ExtendedQueryColumnDataType.State)) {
                        self.statusUniqueIdentifier = null;
                        self.processType = null;
                        self.processType_id = null;
                        self.processSubType_id = null;
                        self.assignmentClaimIdentifier = null;
                        self.reviewConfigurationIdentifier = null;
                        self.reviewTypeIdentifier = null;
                    }
                    if (self.propertyType === 2 /* Status */
                        || (column != null && column.dataType === ExtendedQueryColumnDataType.Status)) {
                        self.stateUniqueIdentifier = null;
                        self.processType = null;
                        self.processType_id = null;
                        self.processSubType_id = null;
                        self.assignmentClaimIdentifier = null;
                        self.reviewConfigurationIdentifier = null;
                        self.reviewTypeIdentifier = null;
                    }
                    if (column != null && column.dataType === ExtendedQueryColumnDataType.Claim) {
                        self.statusUniqueIdentifier = null;
                        self.stateUniqueIdentifier = null;
                        self.processType = null;
                        self.processType_id = null;
                        self.processSubType_id = null;
                        self.reviewConfigurationIdentifier = null;
                        self.reviewTypeIdentifier = null;
                    }
                    if (column != null && column.dataType === ExtendedQueryColumnDataType.ReviewConfiguration) {
                        self.statusUniqueIdentifier = null;
                        self.stateUniqueIdentifier = null;
                        self.processType = null;
                        self.processType_id = null;
                        self.processSubType_id = null;
                        self.assignmentClaimIdentifier = null;
                        self.reviewTypeIdentifier = null;
                    }
                    if (column != null && column.dataType === ExtendedQueryColumnDataType.ReviewType) {
                        self.statusUniqueIdentifier = null;
                        self.stateUniqueIdentifier = null;
                        self.processType = null;
                        self.processType_id = null;
                        self.processSubType_id = null;
                        self.assignmentClaimIdentifier = null;
                        self.reviewConfigurationIdentifier = null;
                    }
                    self.showParameterName = false;
                    if (self.rightRestrictionType === 1 /* InputParameterValue */
                        || self.rightRestrictionType === 2 /* InputParameterList */) {
                        self.showParameterName = true;
                    }
                    else {
                        self.parameterName = null;
                        self.parameterSchemaPropertyUniqueId = null;
                    }
                    self.showValueTarget = false;
                    if (self.rightRestrictionType === 6 /* Value */) {
                        self.showValueTarget = true;
                        if ((self.propertyType === 1 /* State */ || (column != null && column.dataType === ExtendedQueryColumnDataType.State))
                            && self.stateUniqueIdentifier == null) {
                            self.stateUniqueIdentifier = self.states[0].value;
                        }
                        if ((self.propertyType === 2 /* Status */ || (column != null && column.dataType === ExtendedQueryColumnDataType.Status))
                            && self.statusUniqueIdentifier == null) {
                            self.statusUniqueIdentifier = self.statuses[0].value;
                        }
                        if (self.propertyType === 4 /* ProcessType */
                            && self.processType_id == null) {
                            self.processType_id = self.processTypes[0].value;
                        }
                        if (self.propertyType === 11 /* ProcessSubType */
                            && self.processSubType_id == null) {
                            self.processSubType_id = self.processSubTypes[0].value;
                        }
                        if (column != null && column.dataType === ExtendedQueryColumnDataType.Claim && self.assignmentClaimIdentifier == null) {
                            self.assignmentClaimIdentifier = self.assignmentClaims[0].value;
                        }
                        if (column != null && column.dataType === ExtendedQueryColumnDataType.ReviewConfiguration && self.reviewConfigurationIdentifier == null) {
                            self.reviewConfigurationIdentifier = self.reviewConfigurations[0].value;
                        }
                        if (column != null && column.dataType === ExtendedQueryColumnDataType.ReviewType && self.reviewTypeIdentifier == null) {
                            self.reviewTypeIdentifier = self.reviewTypes[0].value;
                        }
                    }
                    else {
                        self.stateUniqueIdentifier = null;
                        self.statusUniqueIdentifier = null;
                        self.processType = null;
                        self.processType_id = null;
                        self.processSubType_id = null;
                        self.assignmentClaimIdentifier = null;
                        self.reviewConfigurationIdentifier = null;
                        self.reviewTypeIdentifier = null;
                    }
                    self.showParameterTarget = false;
                    if (self.propertyType === 17 /* StateLastUpdatedBy */ ||
                        self.propertyType === 15 /* StatusLastUpdatedBy */ ||
                        self.propertyType === 16 /* StatusLastUpdatedDate */ ||
                        self.propertyType === 18 /* StateLastUpdatedDate */) {
                        if (self.rightRestrictionType !== 0 /* None */
                            && self.rightRestrictionType !== 6 /* Value */
                            && self.rightRestrictionType !== 1 /* InputParameterValue */
                            && self.rightRestrictionType !== 2 /* InputParameterList */
                            && self.rightRestrictionType !== 7 /* SubQuery */) {
                            self.showParameterTarget = true;
                        }
                    }
                    return;
                }
                self.stateChange = ObjectQueryPredicateStateChange.RightRistrictionType;
                //right restriction changed to list input so remove all operators but in
                if (self.rightRestrictionType === 2 /* InputParameterList */
                    || self.rightRestrictionType === 7 /* SubQuery */
                    || self.rightRestrictionType === 9 /* Claim */) {
                    if (self.operatorType !== 11 /* In */
                        && self.operatorType !== 12 /* NotIn */) {
                        self.operatorType = 11 /* In */;
                    }
                }
                else if (self.operatorType === 11 /* In */
                    || self.operatorType === 12 /* NotIn */) {
                    //changed from a list type, so set operator to equals
                    self.operatorType = 0 /* Equals */;
                }
                if (self.rightRestrictionType === 1 /* InputParameterValue */
                    || self.rightRestrictionType === 2 /* InputParameterList */) {
                    self.rightParameterTreeItem = null;
                    self.codeValueUniqueIdentifier = null;
                }
                else if (self.rightRestrictionType === 0 /* None */) {
                    self.rightParameterTreeItem = null;
                    self.codeValueUniqueIdentifier = null;
                    self.parameterName = null;
                    self.parameterSchemaPropertyUniqueId = null;
                }
                else if (self.rightRestrictionType === 6 /* Value */) {
                    self.rightParameterTreeItem = null;
                    self.parameterName = null;
                    self.parameterSchemaPropertyUniqueId = null;
                }
                else {
                    self.codeValueUniqueIdentifier = null;
                    self.parameterName = null;
                    self.parameterSchemaPropertyUniqueId = null;
                }
                self.showParameterTarget = false;
                if (self.leftReportDataTreeItem != null || (column != null && (column.dataType !== ExtendedQueryColumnDataType.State && column.dataType !== ExtendedQueryColumnDataType.Status))) {
                    if (self.rightRestrictionType !== 0 /* None */
                        && self.rightRestrictionType !== 6 /* Value */
                        && self.rightRestrictionType !== 1 /* InputParameterValue */
                        && self.rightRestrictionType !== 2 /* InputParameterList */
                        && self.rightRestrictionType !== 7 /* SubQuery */) {
                        self.showParameterTarget = true;
                    }
                }
                self.showParameterName = false;
                if (self.leftReportDataTreeItem != null || column != null) {
                    if (self.rightRestrictionType === 1 /* InputParameterValue */
                        || self.rightRestrictionType === 2 /* InputParameterList */) {
                        self.showParameterName = true;
                    }
                }
                self.showValueTarget = false;
                if (self.leftReportDataTreeItem != null || column != null) {
                    if (self.rightRestrictionType === 6 /* Value */) {
                        if ((self.leftReportDataTreeItem != null && self.leftReportDataTreeItem.schemaProperty.codeGroup_id != null)
                            || (column != null
                                && (column.dataType === ExtendedQueryColumnDataType.State
                                    || column.dataType === ExtendedQueryColumnDataType.Status
                                    || column.dataType === ExtendedQueryColumnDataType.Claim
                                    || column.dataType === ExtendedQueryColumnDataType.ReviewConfiguration
                                    || column.dataType === ExtendedQueryColumnDataType.ReviewType))) {
                            self.showValueTarget = true;
                        }
                        else if ((self.leftReportDataTreeItem != null && self.leftReportDataTreeItem.variableType === 6 /* Boolean */)
                            || (column != null && column.dataType === ExtendedQueryColumnDataType.Boolean)) {
                            self.showValueTarget = true;
                        }
                    }
                }
                self.setValidValues(isProcessLevel);
            };
            ObjectQueryPredicate.prototype.removeAllRightRestrictionsExcept = function (members) {
                var self = this;
                var all = [
                    0 /* None */,
                    4 /* Constant */,
                    2 /* InputParameterList */,
                    1 /* InputParameterValue */,
                    5 /* PlaceHolder */,
                    8 /* Calculation */,
                    3 /* Property */,
                    7 /* SubQuery */,
                    6 /* Value */
                ];
                var remove = Enumerable.from(all).except(members).toArray();
                for (var i = 0; i < remove.length; i++) {
                    self.rightRestrictionTypeContext.removeSpecifiedOptions.push(remove[i]);
                }
            };
            ObjectQueryPredicate.prototype.removeAllOperatorsExcept = function (members) {
                var self = this;
                var all = [
                    0 /* Equals */,
                    3 /* GreaterThan */,
                    9 /* IsNull */,
                    10 /* IsNotNull */,
                    2 /* GreaterThanOrEqual */,
                    11 /* In */,
                    12 /* NotIn */,
                    5 /* LessThan */,
                    4 /* LessThanOrEqual */,
                    8 /* LikeAnywhere */,
                    7 /* LikeEnd */,
                    6 /* LikeStart */,
                    1 /* NotEqual */
                ];
                var remove = Enumerable.from(all).except(members).toArray();
                for (var i = 0; i < remove.length; i++) {
                    self.operatorTypeContext.removeSpecifiedOptions.push(remove[i]);
                }
            };
            return ObjectQueryPredicate;
        }(BaseEntity));
        models.ObjectQueryPredicate = ObjectQueryPredicate;
    })(models = warsApp.models || (warsApp.models = {}));
})(warsApp || (warsApp = {}));
